import type { ContactUsRequest, CountryByIpResponse } from '@models';

import { dashboardApi } from './dashboard-base-api';

const PUBLIC_PREFIX = '/webapi/public';
const ORG_PREFIX = '/webapi/organization';

export const contactUsApiSlice = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        publicContactUs: build.mutation<string, ContactUsRequest>({
            query({ body }) {
                return {
                    url: `${PUBLIC_PREFIX}/contact`,
                    method: 'POST',
                    body,
                };
            },
        }),

        simpleContactUS: build.mutation<string, ContactUsRequest>({
            query({ body }) {
                const { message, organization_id } = body;

                return {
                    url: `${ORG_PREFIX}/simple-contact`,
                    method: 'POST',
                    body: { message, organization_id },
                };
            },
        }),

        getCountryByIp: build.query<CountryByIpResponse, void>({
            query: () => ({ url: `${PUBLIC_PREFIX}/country/ip`, method: 'GET' }),
        }),
    }),
});

export const { usePublicContactUsMutation, useSimpleContactUSMutation, useGetCountryByIpQuery } =
    contactUsApiSlice;
